<template>
  <el-dialog title="" :visible.sync="dialogVisible" width="540px">
    <div class="topTitle">
      <span v-if="data.bsFlag == '买入'" class="buyTitle">买入订单</span>
      <span v-if="data.bsFlag == '卖出'" class="sellTitle">卖出订单</span>
      止盈/止损
    </div>
    <div class="nameStyle">
      {{ data.commodityCode }}&nbsp;&nbsp;{{ data.commodityName }}
    </div>
    <div class="markupP">
      <div>涨停价:{{ CommodityHighLow.high }}</div>
      <div>跌停价:{{ CommodityHighLow.low }}</div>
    </div>
    <div class="inputWrap wrapYing">
      <p class="title">
        <span>止盈</span>（止盈价格距现价最少不{{
          data.bsFlag == '买入' ? '低' : '高'
        }}于0.5%）
      </p>
      <div class="content">
        <el-checkbox v-model="checkedzy"></el-checkbox>
        <el-input v-model="profitPrice" :placeholder="closeProPrice" @input="profitAccurac">
          <template slot="suffix">
            <span>{{ data.bsFlag == '买入' ? '>=' : '<=' }}{{ closeProPrice }}</span>
          </template>
        </el-input>
        <div class="textStyle">
          最低止盈价不{{ data.bsFlag == '买入' ? '低' : '高' }}于<span>{{
            closeProPrice
          }}</span>
        </div>
      </div>
    </div>
    <div class="inputWrap wrapSun">
      <p class="title">
        <span>止损</span>（止损价格距现价最少不{{
          data.bsFlag == '买入' ? '高' : '低'
        }}于0.5%）
      </p>
      <div class="content">
        <el-checkbox v-model="checkedzs"></el-checkbox>
        <el-input v-model="lossPrice" :placeholder="closeLossPrice" @input="lossAccurac">
          <template slot="suffix">
            <span>{{ data.bsFlag == '买入' ? '<=' : '>=' }}{{ closeLossPrice }}</span>
          </template>
        </el-input>
        <div class="textStyle">
          最低止损价不{{ data.bsFlag == '买入' ? '高' : '低' }}于<span>{{
            closeLossPrice
          }}</span>
        </div>
      </div>
    </div>
    <div class="newTip">
      注:极端行情下，止损委托有可能出现不成交现象。请随时关注行情变化。
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="conBtn"
        type="primary"
        style="color:#fff"
        @click="stopConfirm"
      >确 定</el-button>
        <el-button
        class="canelBtn"
        @click="cancleDialog"
      >取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
/*global http protocol util*/
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      checkedzy: false, // 止盈
      checkedzs: false, // 止损
      dialogVisible: false,
      data: {},
      input: '',
      profitPrice: null,
      lossPrice: null,
      isRepeat: false,
      CommodityHighLow: { low: '0.00', high: '0.00' }
    }
  },
  computed: {
    ...mapGetters(['sessionInfoGetter', 'marketDetails', 'commodityStrategyGetter']),
    item() {
      const item = this.$store.state.hqData.item.symbol
      if (item) {
        // this.selfItem = this.$store.state.hqData.item
        // this.symbol = this.$store.state.hqData.item.symbolId
        // this.commodityCode = this.$store.state.hqData.item.commodityCode
        return this.$store.state.hqData.item.symbol
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          // this.selfItem = this.$store.state.hqData.marketDetails[0]
          // this.symbol = this.$store.state.hqData.marketDetails[0].symbolId
          // this.commodityCode = this.$store.state.hqData.marketDetails[0].commodityCode
          return this.$store.state.hqData.marketDetails[0].symbol
        } else {
          // this.selfItem = null
          // this.symbol = '--'
          // this.commodityCode = '--'
          return '--'
        }
      }
    },
    itemdata() {
      const item = this.$store.state.hqData.item.symbolId
      if (item) {
        return item
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].symbolId
        } else {
          return '--'
        }
      }
    },
    closeProPrice() {
      // 止盈价标准
      // 买持仓的止盈价格高于止损价格（止盈价格要大于当前价-0.5%，止损价格要小于当前价+0.5%）
      // 卖持仓的止盈价格低于止损价格（止盈价格要小于当前价+0.5%，止损价格要大于当前价-0.5%

      // 买入订单止盈价需要向上取整，止损价向下取整。卖出订单的止盈价需要向下取整，止损价向上取整
      for (let i = 0; i < this.marketDetails.length; i++) {
        const ele = this.marketDetails[i]
        if (this.data.commodityId == ele.symbolId) {
          if (this.data.bsFlag == '买入') {
            return util.ceilFun(Number(util.floatMul(ele.close, 1.005)), this.data.priceScale)
          } else {
            return util.floorFun(Number(util.floatMul(ele.close, 0.995)), this.data.priceScale)
          }
        }
      }
      return ''
    },
    closeLossPrice() {
      // 损价标准
      // 买持仓的止盈价格高于止损价格（止盈价格要大于当前价-0.5%，止损价格要小于当前价+0.5%）
      // 卖持仓的止盈价格低于止损价格（止盈价格要小于当前价+0.5%，止损价格要大于当前价-0.5%

      // 买入订单止盈价需要向上取整，止损价向下取整。卖出订单的止盈价需要向下取整，止损价向上取整
      for (let i = 0; i < this.marketDetails.length; i++) {
        const ele = this.marketDetails[i]
        if (this.data.commodityId == ele.symbolId) {
          if (this.data.bsFlag == '买入') {
            return util.floorFun(Number(util.floatMul(ele.close, 0.995)), this.data.priceScale)
            // return Number(util.floatMul(ele.close, 0.995)).toFixed(2)
          } else {
            return util.ceilFun(Number(util.floatMul(ele.close, 1.005)), this.data.priceScale)
            // return Number(util.floatMul(ele.close, 1.005)).toFixed(2)
          }
        }
      }
      return ''
    }
  },
  watch: {
    // checkedzy(val) {
    //   if (this.data.bsFlag === '买入' && this.CommodityHighLow.high < this.closeProPrice) {
    //     this.checkedzy = false
    //     return this.$message('止盈价格不能高于涨停价')
    //   }
    //   if (this.data.bsFlag === '卖出' && this.CommodityHighLow.low < this.closeProPrice) {
    //     this.checkedzy = false
    //     return this.$message('止盈价格不能高于跌停价')
    //   }
    // },
    // checkedzs(val) {
    //   if (this.data.bsFlag === '买入' && this.CommodityHighLow.low < this.closeLossPrice) {
    //     this.checkedzs = false
    //     return this.$message('止损价格不能高于跌停价')
    //   }
    //   if (this.data.bsFlag === '卖出' && this.CommodityHighLow.high < this.closeLossPrice) {
    //     this.checkedzs = false
    //     return this.$message('止损价格不能高于涨停价')
    //   }
    // }
  },
  updated() {
  },
  methods: {
    cancleDialog() {
      this.dialogVisible = false
      this.checkedzy = false // 止盈
      this.checkedzs = false // 止损
    },
    profitAccurac(value) {
      if (value) {
        const numStr = new RegExp('^(\\d+)\\.(\\d{0,' + this.data.priceScale + '}).*$')
        value = value.replace(numStr, '$1.$2')
        this.profitPrice = value
      }
    },
    lossAccurac(value) {
      if (value) {
        const numStr = new RegExp('^(\\d+)\\.(\\d{0,' + this.data.priceScale + '}).*$')
        value = value.replace(numStr, '$1.$2')
        this.lossPrice = value
      }
    },
    // 商品涨停跌停价查询
    findCommodityHighLow(symbol) {
      protocol.findCommodityHighLow.data.commodityId = symbol
      http.gPost(protocol.findCommodityHighLow).then(response => {
        if (response.data) {
          if (response.data && response.data.code == '0') {
            this.CommodityHighLow = response.data.value
          }
        }
      })
    },
    showDialog(row) {
      this.data = row
      this.dialogVisible = true
      this.profitPrice = this.closeProPrice
      this.lossPrice = this.closeLossPrice
      this.findCommodityHighLow(row.commodityId)
    },
    isEmpty(param) {
      if (param === null || param === undefined || param === '') {
        return true
      } else {
        return false
      }
    },
    stopConfirm() {
      const reg = /^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/
      if (!this.checkedzs && !this.checkedzy) {
        return this.$message('请设置止盈或止损')
      }
      if (this.data.bsFlag == '买入' && this.profitPrice && this.profitPrice != 0) {
        if (this.checkedzy &&
          this.profitPrice
        ) {
          if (!reg.test(this.profitPrice)) {
            return this.$message('止盈价为大于0的数值')
          }
        }
        if (this.checkedzs &&
          this.lossPrice
        ) {
          if (!reg.test(this.lossPrice)) {
            return this.$message('止损价为大于0的数值')
          }
        }
        if (this.checkedzy &&
          this.profitPrice &&
          Number(this.profitPrice) < Number(this.closeProPrice)
        ) {
          return this.$message('最低止盈价不低于0.5%')
        }
        if (this.checkedzs &&
          this.lossPrice &&
          Number(this.lossPrice) > Number(this.closeLossPrice)
        ) {
          return this.$message('最低止损价不高于0.5%')
        }
        if (this.isEmpty(this.profitPrice) && this.isEmpty(this.lossPrice)) {
          return this.$message('请输入止盈或者止损价')
        }
      } else if (this.data.bsFlag == '卖出' && this.lossPrice && this.lossPrice != 0) {
        if (this.checkedzy &&
          this.profitPrice
        ) {
          if (!reg.test(this.profitPrice)) {
            return this.$message('止盈价为大于0的数值')
          }
        }
        if (this.checkedzs &&
          this.lossPrice
        ) {
          if (!reg.test(this.lossPrice)) {
            return this.$message('止损价为大于0的数值')
          }
        }
        if (this.checkedzy &&
          this.profitPrice &&
          Number(this.profitPrice) > Number(this.closeProPrice)
        ) {
          return this.$message('最低止盈价不高于0.5%')
        }
        if (this.checkedzs &&
          this.lossPrice &&
          Number(this.lossPrice) < Number(this.closeLossPrice)
        ) {
          return this.$message('最低止损价不低于0.5%')
        }
        if (this.isEmpty(this.profitPrice) && this.isEmpty(this.lossPrice)) {
          return this.$message('请输入止盈或者止损价')
        }
      }

      if (this.isRepeat) {
        return
      } else {
        this.isRepeat = true
      }
      protocol.param_addStopPrice.param = {
        holdDetailId: this.data.holdDetailId,
        stopLossPrice: this.lossPrice ? Number(this.lossPrice) : 0,
        stopProfitPrice: this.profitPrice ? Number(this.profitPrice) : 0
      }
      // 传null代表不作处理
      if (!this.checkedzs) {
        protocol.param_addStopPrice.param.stopLossPrice = null
      }
      if (!this.checkedzy) {
        protocol.param_addStopPrice.param.stopProfitPrice = null
      }
      http.postFront1(protocol.param_addStopPrice).then(response => {
        const { code, message } = response.data
        this.$message(message)
        if (code == '0') {
          this.isRepeat = false
          this.dialogVisible = false
          this.checkedzy = false // 止盈
          this.checkedzs = false // 止损
          this.$emit('reLoad')
        } else {
          this.isRepeat = false
        }
      }).catch(error => {
        this.$message(error)
        this.isRepeat = false
      })
      // this.dialogVisible = false
      // this.$emit('reLoad')
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-table table tr{
   background-color: #161719;
}
/deep/ .el-dialog input,
/deep/ .el-dialog .el-input__inner {
  margin: 0 14px;
  border: 1px solid rgba(220, 223, 230, 0.6) !important;
  background-color: transparent;
}
/deep/.el-input__prefix,
/deep/.el-input__suffix {
  top: 6px;
}
/deep/ .el-dialog {
  background: #1A1A1A !important;
border-radius: 8px;
border: 1px solid #545454;
  font-size: 18px;
  height: 428px;
  // padding-top: 30px;
  .el-dialog__headerbtn {
    display: none;
  }
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    
    padding: 20px 81px 0 81px !important;
  }

  .el-button{
    width: 74px;
    height: 24px;
    font-family: Source Han Sans SC;
  font-weight: 400;
  font-size: 14px;
  color: #DFDFDF;
  padding: 0;
  border-radius: 12px;
  }
  .conBtn{
    background: #272727;
    border: none;
  }
  .canelBtn{
    background-color: transparent;
border: 1px solid #404040;
  }
  .el-dialog__footer {
    text-align: center;
    padding: 20px 0 20px 0;
  }
  .el-checkbox{
    margin-right: 10px;
    height: 32px;
    line-height: 32px;
  }
  .markupP{
    color: #d7d7d7;
  }
  .topTitle {
    text-align: center;
    color: #bcbcbc;
    font-family: Source Han Sans SC;
    font-weight: 600;
    font-size: 20px;
    .buyTitle {
      margin-right: 11px;
      color: #D94066;
    }
    .sellTitle {
      color: #41b37d;
    }
  }
  .el-dialog__body{
    padding: 20px 40px 0 40px;
  }
  .nameStyle {
    font-family: Source Han Sans SC;
    font-weight: 400;
    font-size: 16px;
     color: #FFFFFF;
    text-align: center;
    padding: 10px 0 15px 0;
    padding-bottom: 0px;
  }
  .inputWrap {
    .title {
      color: #B2B2B2;
      padding-bottom: 10px;
      margin-top: 20px;
    }
    .content {
      display: flex;
      .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
          background-color: #FFFFFF;
          border-color: #FFFFFF;
          &::after {
            border-color: #000000;
          }
      }
      .el-input__inner{
        line-height: 40px;
        color: #FFFFFF !important;
      }
      .el-input {
        width: 180px;
        height: 40px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
      }
      .el-input__suffix{
        top: 2px;
      }
      .el-input__suffix-inner {
        line-height: 32px;
        span {
          font-family: Source Han Sans SC;
          font-weight: 400;
          font-size: 12px;
          color: #ABABAB;
        }
      }
      .textStyle {
       color: #ABABAB;
        height: 32x;
        line-height: 32px;
        padding-left: 29px;
        span {
         color: #ABABAB;
        }
      }
    }
  }
  .wrapYing {
    .title {
      span {
       font-family: Source Han Sans SC;
        font-weight: 400;
        font-size: 14px;
        color: #D94066;
      }
    }
  }
  .wrapSun {
    .title {
      span {
        color: #41B37D;
      }
    }
  }
  .newTip{
    font-size: 14px;
   color: #D94066;
    line-height: 20px;
    margin-top:14px;
  }
}
</style>
